import axios from 'axios';
import { useRuntimeConfig } from 'nuxt/app';

export const useGeoLocation = () => {
  const config = useRuntimeConfig();
  
  const getGeoLocation = async () => {
    try {
      const response = await axios.get(`${config.public.geoApiUrl}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching geolocation:', error);
      return null;
    }
  };

  return {
    getGeoLocation
  };
}; 